// extracted by mini-css-extract-plugin
export var currencyInput = "_lf-1";
export var currencySymbol = "_lf-0";